import nftOwner1 from "../../assets/images/avatars/avatar3.png";
import nftOwner2 from "../../assets/images/avatars/avatar4.png";
import nftOwner3 from "../../assets/images/avatars/avatar5.png";
import nftOwner4 from "../../assets/images/avatars/avatar6.png";
import nft1 from "../../assets/images/nfts/nft1.png";
import nft2 from "../../assets/images/nfts/nft2.png";
import nft3 from "../../assets/images/nfts/nft3.png";
import nft4 from "../../assets/images/nfts/nft4.png";
import { getRandomTime } from "../../utils/getRandomTime";

export const nftData = [
    {
        id: 1,
        img: nft1,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'ArtCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 2,
        img: nft2,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'This NFT',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 3,
        img: nft3,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'NameCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 4,
        img: nft4,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'KingCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 5,
        img: nft4,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'ArtCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 6,
        img: nft3,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'This NFT',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 7,
        img: nft1,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'NameCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 8,
        img: nft2,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'KingCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 9,
        img: nft1,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'ArtCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 10,
        img: nft4,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'This NFT',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 11,
        img: nft2,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'NameCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 12,
        img: nft3,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'KingCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 13,
        img: nft3,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'ArtCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 14,
        img: nft2,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'This NFT',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 15,
        img: nft1,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'NameCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
    {
        id: 16,
        img: nft4,
        avatar: [nftOwner1, nftOwner2, nftOwner3, nftOwner4],
        title: 'KingCrypto',
        price: 0.25,
        nftNumber: 1,
        totalNftNumber: 321,
        timeLeft: getRandomTime(),
    },
];